"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ColorPalette = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _recoil = require("recoil");

var _RecoilStates = require("../contexts/RecoilStates");

var __jsx = _react["default"].createElement;

var ColorPalette = function ColorPalette(_ref) {
  var currentColor = _ref.currentColor,
      onChange = _ref.onChange;
  var colors = (0, _recoil.useRecoilValue)(_RecoilStates.ColorsState);
  return __jsx(_react["default"].Fragment, null, colors.length > 0 && __jsx(_react2.Stack, null, __jsx(_react2.Text, null, "Couleurs pr\xE9d\xE9finies"), __jsx(_react2.HStack, null, colors.map(function (color, index) {
    return __jsx(_react2.Box, {
      onClick: function onClick() {
        return onChange && onChange(color);
      },
      position: "relative",
      cursor: "pointer",
      display: "inline-block",
      h: "4",
      w: "4",
      backgroundColor: color,
      key: index
    }, (color.toLowerCase() === "#fff" || color.toLowerCase() === "#ffffff" || color.toLowerCase() === "white") && __jsx(_react2.Box, {
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
      border: "1px solid #A0AEC0"
    }), currentColor && color.toLowerCase() === currentColor.toLowerCase() && __jsx(_react2.Box, {
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
      border: "2px solid #EAA82F"
    }));
  }))));
};

exports.ColorPalette = ColorPalette;